import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';

const ProductListAbout = ({ productList: { description, isShoppingHome },
  shoppingNavigationItems: { pageTitle } }) => {

  return (
    <div className="about-wrapper">
      <div className={'content'}>
        <h4>{pageTitle}</h4>
        {
          isShoppingHome
            ? <RosettaFormattedMessage parentFilename={__filename}
              id="about_shopping"
              description="Text above the description for the product list homepage"
              defaultMessage="about shopping"
              /> // eslint-disable-line indent
            : <RosettaFormattedMessage parentFilename={__filename}
              id="about"
              description="Text above the description for a product list page"
              defaultMessage="about"
              /> // eslint-disable-line indent
        }
        <p>
          {description}
        </p>
      </div>
    </div>
  );
};

ProductListAbout.propTypes = {
  productList: PropTypes.shape({
    description: PropTypes.string,
    isShoppingHome: PropTypes.bool
  }),
  shoppingNavigationItems: PropTypes.shape({
    pageTitle: PropTypes.string
  })
};

export default ProductListAbout;
